/**
 * Created by Administrador on 4/3/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('boardingGateService', boardingGateService);

    boardingGateService.$inject = ['$http', 'CONFIG'];

    function boardingGateService($http, CONFIG){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/boardingGates';

        return {
            getBoardingGates: function(){
                return $http.get(urlBase)
            },

            getBoardingGate: function(id){
                return $http.get(urlBase + "/" + id);
            },

            saveBoardingGate: function(boardingGate){
                return $http.post(urlBase, boardingGate)
            },

            updateBoardingGate: function(boardingGate){
                return $http.put(urlBase + "/" + boardingGate.rId, boardingGate)
            },

            deleteBoardingGate: function(id){
                return $http.delete(urlBase + "/" + id)
            },

            getBoardingGatesByAirport: function(airportId){
                return $http.get(urlBase + "/" + airportId + "/airport")
            }
        };
    }
})();
